// extracted by mini-css-extract-plugin
export default {"resultValue":"ResultIndicator_resultValue__EGryf","resultLabel":"ResultIndicator_resultLabel__6iCwi","resultNumber":"ResultIndicator_resultNumber__ZEwNg"};